import { useEffect, useState } from "react";
// store
import useStore from "../../store";
// css
import "./categories.css";
import Products from "./Products";

export default function Categories() {
  const { categories, selectedCategory, setSelectedCategory } = useStore(
    (state) => state
  );

  const [selectedParentCategory, setSelectedParentCategory] = useState(null);

  useEffect(() => {
    if (categories.length > 0) {
      setSelectedCategory(categories[0].id);
    }
  }, [categories, setSelectedCategory]);

  return (
    <div className="container category_list">
      {!selectedParentCategory ? (
        <div className="flex justify-center flex-wrap gap-4 max-w-[100%] mb-[20px]">
          {categories.map((category) => (
            <Item
              key={category.id}
              category={category}
              setSelectedParentCategory={setSelectedParentCategory}
              setSelectedCategory={setSelectedCategory}
            />
          ))}
        </div>
      ) : (
        <div
          className="back-button"
          onClick={() => setSelectedParentCategory(null)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-arrow-left"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </div>
      )}

      {selectedParentCategory?.children?.length > 0 && (
        <>
          <div className="flex flex-wrap gap-4 category_children mb-4">
            {selectedParentCategory?.children.map((child) => (
              <div
                key={child.id}
                className={`category-child-btn ${
                  selectedCategory === child.id ? "active" : ""
                }`}
                onClick={() => setSelectedCategory(child.id)}
              >
                <h3>{child.name}</h3>
              </div>
            ))}
          </div>

          {/* Products Component */}
        </>
      )}
      {selectedParentCategory?.children && (
        <Products selectedCategory={selectedCategory} />
      )}
    </div>
  );
}

// Main Category Item
const Item = ({
  category,
  selectedCategory,
  setSelectedCategory,
  setSelectedParentCategory,
}) => {
  const isSelected =
    selectedCategory === category.id ||
    category?.children?.some((child) => child.id === selectedCategory);

  const handleClick = () => {
    setSelectedParentCategory(category);

    if (category.children && category.children.length > 0) {
      setSelectedCategory(category.children[0].id);
    } else {
      setSelectedCategory(category.id);
    }
  };

  return (
    <div
      className={`category-card ${isSelected ? "active" : ""}`}
      style={{
        backgroundImage: category?.file
          ? `url(${category.file.domain}${category.file.folder}${category.file.file})`
          : `url(${process.env.PUBLIC_URL + "/zimzim.png"})`,
      }}
      onClick={handleClick}
    >
      <div className="category-name">{category.name}</div>
    </div>
  );
};
